import Lenis from "lenis";

let lenis = null;

export function initSmoothScroll() {
  if (lenis) return lenis;
  if (typeof window === "undefined") return null;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null;
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
  return lenis;
}

export function destroySmoothScroll() {
  lenis?.destroy();
  lenis = null;
}

export function stopScroll() {
  lenis?.stop();
  document.body.style.overflow = "hidden";
}

export function resumeScroll() {
  lenis?.start();
  document.body.style.overflow = "";
}

export function scrollToSection(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -64, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
}
